export default __webpack_public_path__ + "static/media/bindAccountSuccessIcon.e3a8c618.svg";